import AccountStore from "../stores/AccountStore"
import moment from "moment"
import { IHolidayPaygroupInstance, IHolidayTemplate } from "../models"

export function checkDuplicatedDateForPayGroup(holidayPaygroupInstances: IHolidayPaygroupInstance[]): boolean {
    const dates: Date[] = []
    const holidays: IHolidayTemplate[] = []
    holidayPaygroupInstances.forEach(item => {
        holidays.push(AccountStore.getCurrentAccount().HolidayTemplates.find(template => template.Id === item.HolidayTemplateId))
    })
    const duplicatedDateHoliday = holidays.find(holiday => {
        return holiday.Dates.find(date => {
            if (dates.find(existDate => moment(existDate).isSame(date))) {
                return true
            }
            else {
                dates.push(date)
                return false
            }
        })
    })
    return duplicatedDateHoliday ? true : false
}

export function checkDuplicatedDateForHolidayTemplate(updateHolidayTemplateId: string, newDates: Date[]): boolean {

    const existDates: Date[] = []
    AccountStore.getCurrentAccount().PayGroups.forEach(payGroup => {
        if (payGroup.Holidays && payGroup.Holidays.find(holiday => holiday.HolidayTemplateId === updateHolidayTemplateId)) {
            payGroup.Holidays.forEach(holiday => {
                if (holiday.HolidayTemplateId !== updateHolidayTemplateId) {
                    existDates.push(...AccountStore.getCurrentAccount().HolidayTemplates.find(item => item.Id === holiday.HolidayTemplateId).Dates)
                }
            })
        }
    })
    return newDates.find(newDate => existDates.find(existDate => moment(newDate).isSame(existDate)) !== undefined) !== undefined
}